import {
  createCompany as createCompanyRequest,
  getCompany as getCompanyRequest,
  listCompanies as listCompaniesRequest,
  updateCompany as updateCompanyRequest
} from '@cbgms/api/modules/company/requests'
import {
  ILicenseByUUIDResponse,
  IUpdateLicenseForCompanyBody,
  createLicenseForCompany as createLicenseForCompanyRequest,
  deleteLicenseForCompany as deleteLicenseForCompanyRequest,
  getLicenseByUUID as getLicenseByUUIDRequest,
  getLicenses,
  updateLicenseForCompany as updateLicenseForCompanyRequest
} from '@cbgms/api/support'
import {
  GETCompaniesResponse,
  ICompany,
  ICreateLicenseForCompanyBody,
  ILicenseForCompanyResponse,
  IResponse,
  POSTSearchUserBody,
  POSTSearchUserResponse
} from '@cbgms/api'
import { IPaginatedRequest } from '@cbgms/api/request'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { searchUserRequest } from '@cbgms/api/modules/employees/requests'

export const listCompanies = (params: IPaginatedRequest) =>
  AsyncAction<GETCompaniesResponse>({
    type: [types.GET_COMPANIES, types.GET_COMPANIES_SUCCESS, types.GET_COMPANIES_FAILED],
    payload: {
      api: 'support',
      request: listCompaniesRequest(params)
    }
  })

export const getCompany = (companyUUID: string) => ({
  type: [types.GET_COMPANY, types.GET_COMPANY_SUCCESS, types.GET_COMPANY_FAILED],
  payload: {
    api: 'support',
    request: getCompanyRequest(companyUUID)
  }
})

export const createCompany = (data: Partial<ICompany>) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.CREATE_COMPANY, types.CREATE_COMPANY_SUCCESS, types.CREATE_COMPANY_FAILED],
    payload: {
      api: 'support',
      request: createCompanyRequest(data)
    }
  })

export const updateCompany = (companyUUID: string, data: Partial<ICompany>) => ({
  type: [types.UPDATE_COMPANY, types.UPDATE_COMPANY_SUCCESS, types.UPDATE_COMPANY_FAILED],
  payload: {
    api: 'support',
    request: updateCompanyRequest(companyUUID, data)
  }
})

export const resetCompany = () => ({
  type: types.RESET_COMPANY_STATE
})

export const getLicensesForCompany = (params: IPaginatedRequest) =>
  AsyncAction<ILicenseForCompanyResponse>({
    type: [types.GET_COMPANY_LICENSES, types.GET_COMPANY_LICENSES_SUCCESS, types.GET_COMPANY_LICENSES_FAILED],
    payload: {
      api: 'support',
      request: getLicenses(params)
    }
  })

export const getLicenseByUUID = (uuid: string) =>
  AsyncAction<ILicenseByUUIDResponse>({
    type: [types.GET_LICENSES, types.GET_LICENSES_SUCCESS, types.GET_LICENSES_FAILED],
    payload: {
      api: 'support',
      request: getLicenseByUUIDRequest(uuid)
    }
  })

export const createLicenseForCompany = (data: ICreateLicenseForCompanyBody) =>
  AsyncAction<ILicenseByUUIDResponse>({
    type: [types.CREATE_COMPANY_LICENSE, types.CREATE_COMPANY_LICENSE_SUCCESS, types.CREATE_COMPANY_LICENSE_FAILED],
    payload: {
      api: 'support',
      request: createLicenseForCompanyRequest(data)
    }
  })

export const updateLicenseForCompany = (data: IUpdateLicenseForCompanyBody) =>
  AsyncAction({
    type: [types.UPDATE_COMPANY_LICENSE, types.UPDATE_COMPANY_LICENSE_SUCCESS, types.UPDATE_COMPANY_LICENSE_FAILED],
    payload: {
      api: 'support',
      request: updateLicenseForCompanyRequest(data)
    }
  })

export const deleteLicenseForCompany = (licenseUUID: string, dryRun: boolean) => ({
  type: [types.DELETE_COMPANY_LICENSE, types.DELETE_COMPANY_LICENSE_SUCCESS, types.DELETE_COMPANY_LICENSE_FAILED],
  payload: {
    api: 'support',
    request: deleteLicenseForCompanyRequest(licenseUUID, dryRun)
  }
})

export const searchUser = (data: POSTSearchUserBody) => {
  return AsyncAction<POSTSearchUserResponse>({
    type: [types.SEARCH_USER, types.SEARCH_USER_SUCCESS, types.SEARCH_USER_FAILED],
    payload: {
      api: 'support',
      request: searchUserRequest(data)
    }
  })
}
